import styled from "styled-components";
import {Image} from "antd";

export const MyImageStyles = styled(Image)`
  
`